import { useTheme } from 'vuetify';
export function useAppColors() {
  const theme = useTheme();

  /**
   * @param {Object.<string, string>[]} colors
   */
  function updateColors(colors) {
    if (colors.base0) {
      colors.background = colors.base0;
      colors.surface = colors.base0;
    }
    theme.themes.value[theme.name.value].colors = {
      ...theme.current.value.colors,
      ...colors,
    };
  }

  /**
   * Takes string that can be parsed as a css color value or a vuetify themed color and returns the colors' hex code
   * @param str
   * @param opacity
   * @returns {string}
   */
  function getColorHex(str, opacity = 1) {
    if (theme.computedThemes.value?.[theme.name.value].colors[str]) {
      return hexadecimal(theme.computedThemes.value?.[theme.name.value].colors[str], opacity);
    }

    const ctx = document.createElement('canvas').getContext('2d');
    ctx.fillStyle = str;
    return hexadecimal(ctx.fillStyle, opacity);
  }

  function hexadecimal(color, opacity) {
    const decimal = `0${Math.round(255 * opacity).toString(16)}`.slice(-2).toUpperCase();
    if (color.length === 4) {
      color += color.slice(1);
    }
    return color + decimal;
  }

  return {
    theme,
    updateColors,
    getColorHex,
  };
}
